// Node imports
import {
  Bitmap,
  Container,
  IGraphics,
  ITween,
  Linear,
  SpineBase,
  delayedCall,
  dispatcher,
  ingenuity,
  killDelayedCall,
} from "@quest/base-core";
import {
  IntroOutroControllerBehavior,
  SoundConstant,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
  ButtonBaseBehavior,
} from "@quest/murka-games-behavior-leopard/dist/";
import { IntroOutroViewGame } from "./IntroOutroViewGame";
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { gameConstants } from "../Constants/gameConstants";
import { Emitter } from "@quest/pixi-bridge";
import { MeterBitmapGame } from "../UI/MeterBitmapGame";
import { SlotEventConstants } from "@quest/slot-core";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";

export class IntroOutroControllerGame extends IntroOutroControllerBehavior {
  protected view: IntroOutroViewGame;
  protected introTextSpine: SpineBase;
  private introSpineContainer: Container;
  protected outroTextSpine: SpineBase;
  private outroWinTickupCont: Container;
  private tapToClickContainer: Container;
  private tapToClickContainerOutro: Container;
  private jackpotUIArray: any[] = [];
  private jackpotBlockBG: IGraphics;
  private MULTIPLIER_CONTAINER: string = "_multiplier_container";
  private CONTAINER: string = "_container";
  private OUTRO_PLUS: string = "outro_Plus_";
  private METER_STR: string = "_meter";
  private coinShowerContainerMask: any;
  private grandJpEmitter: Emitter;
  private fgOutroSpinePortrait: SpineBase;
  private outroTextSpinePortrait: SpineBase;
  private fgIntroBGSPine: SpineBase;
  private total_win: Bitmap;

  private plusUIArray: Bitmap[] = [];
  private continueButton: ButtonBaseBehavior;
  private continueButtonOutroWin: ButtonBaseBehavior;

  /**
   * initializeElements overrided to initialize free game intro spine.
   */
  protected initializeElements(): void {
    super.initializeElements();
    this.coinShowerContainerMask = this.view.getShapeById("coinShowerContainerMask") as any;
    this.introSpineContainer = this.view.getContainerByID("freegame_intro_desktop_cont");
    this.tapToClickContainer = this.view.getContainerByID("taptoclickMessage");
    this.tapToClickContainerOutro = this.view.getContainerByID("OutroTapToContinue");
    this.freeGameIntroSpine = this.introSpineContainer.children[0];
    this.introTextSpine = this.view.getContainerByID("fgIntroSpineMainContainer").children[1].children[0];
    this.fgOutroSpine = this.view.getContainerByID("freegame_outro_Container_Desktop_BG").children[0];
    this.outroTextSpine = this.view.getContainerByID("Freegame_outro_Desktop_Container_Character").children[0];
    this.outroWinTickupCont = this.view.getContainerByID("outroMeterContainer");
    this.OutroWinAmount.rotation = 0;
    this.jackpotBlockBG = this.view.getShapeById("jackpotBlockBG");
    this.total_win = this.view.getImageById("total_win");
    this.jackpotBlockBG.x = -380;
    this.jackpotBlockBG.y = 33;
    this.setContainersPivot();
    if (!ingenuity.deviceEnv.isDesktop) {
      this.fgOutroSpinePortrait = this.view.getContainerByID("freegame_outro_Text_Container_BG").children[0];
      this.outroTextSpinePortrait = this.view.getContainerByID("Freegame_outro_Text_Container_Character").children[0];
      this.fgIntroBGSPine = this.view.getContainerByID("fgIntroSpineMainContainerPortrait_BG").children[0];
    }
  }

  /**overrided to initialize game components */
  protected onInitializeIntroOutro(): void {
    super.onInitializeIntroOutro();
    this.continueButton = this.view.getButtonById("continueButtonIntro") as ButtonBaseBehavior;
    this.continueButtonOutroWin = this.view.getButtonById("outro_continue_button") as ButtonBaseBehavior;
    this.continueButtonOutroWin.disableAndTint();
  }

  /**overrided to initialize game components n portrait*/
  protected initializePortraitComponent(): void {
    this.freeGameIntroPortraitSpine = this.view.getSpineById("Freespins_Intro_Portrait");
    this.fgOutroPortraitSpine = this.view.getSpineById("freegame_outro_Portrait");
  }

  /**overrided to bind button handler */
  protected bindHandlers(): void {
    this.continueButton.on(ButtonBaseBehavior.UP, this.onContinuePressUP, this);
    // this.continueButtonOutroWin.on(ButtonBaseBehavior.UP, this.onOutroWinContinuePressUP, this);
  }

  /**overrided to unbind button handler */
  protected unBindHandlers(): void {
    this.continueButton.off(ButtonBaseBehavior.UP, this.onContinuePressUP, this);
  }

  /**
   * setContainersPivot method set pivot for outro win tickup container
   */
  private setContainersPivot(): void {
    this.outroWinTickupCont.setPivot(this.outroWinTickupCont.width / 2, 0);
    this.OutroWinAmount.x = this.total_win.x + this.total_win.width;
  }

  protected onIntroShow(): void {
    super.onIntroShow();
    (ingenuity.parserModel as GameParserModel).setTotalBaseGameWinAmt((ingenuity.parserModel as GameParserModel).getBaseGameWinAmt() + (ingenuity.parserModel as GameParserModel).getPrizePotCredit() + (ingenuity.parserModel as GameParserModel).getGrandJackpotWonBG() + (ingenuity.parserModel as GameParserModel).getMiniJackpotWonBG() + (ingenuity.parserModel as GameParserModel).getMinorJackpotWonBG() + (ingenuity.parserModel as GameParserModel).getMajorJackpotWonBG());
  }
  /**
   * playFgOutroEndSpine method override to stop fgOutroSpine,fgOutroPortraitSpine animation and hide.
   */
  protected playFgOutroEndSpine(): void {
    if (ingenuity.deviceEnv.getOrientation() !== constants.ORIENTATION.PORTRAIT) {
      this.playLandscapeOutroAnimations();
    } else {
      this.playPortraitOutroAnimations();
    }
    this.resetData();
  }

  // Handle outro animations for landscape orientation
  private playLandscapeOutroAnimations(): void {
    this.fgOutroSpine.setPause(false);
    this.outroTextSpine.setPause(false);
    this.fgOutroSpine.playAnim("out_bg_desktop", false);
    this.outroTextSpine.playAnim("out_fg", false);

    this.fgOutroSpine.onComplete.addOnce(() => {
      this.fgOutroSpine.alpha = 0;
      this.outroTextSpine.alpha = 0;
      if (!ingenuity.deviceEnv.isDesktop) {
        this.outroTextSpinePortrait.visible = false;
        this.fgOutroSpinePortrait.visible = false;
      }
    }, this);
  }

  // Handle outro animations for portrait orientation
  private playPortraitOutroAnimations(): void {
    this.outroTextSpinePortrait.setPause(false);
    this.fgOutroSpinePortrait.setPause(false);
    this.fgOutroSpinePortrait.playAnim("out_bg_portrait", false);
    this.outroTextSpinePortrait.playAnim("out_fg", false);

    this.outroTextSpinePortrait.onComplete.addOnce(() => {
      this.outroTextSpinePortrait.setPause(true);
      this.fgOutroSpinePortrait.setPause(true);
      this.outroTextSpinePortrait.visible = false;
      this.fgOutroSpinePortrait.visible = false;
      this.fgOutroSpine.alpha = 0;
      this.outroTextSpine.alpha = 0;
    }, this);
  }

  // reset counter and emitter
  private resetData(): void {
    this.outroWinTickupCont.visible = false;
    if (this.grandJpEmitter) {
      this.grandJpEmitter.emit = false;
      this.grandJpEmitter.autoUpdate = false;
      this.grandJpEmitter.destroy();
    }
  }

  // Method playFgOutroDesktopSpine to play the outro desktop spine
  protected playFgOutroDesktopSpine(): void {
    this.setOutroTickupYPosition();
    this.makeOutroSpinesVisible();
    this.playOutroAnimations();
    this.startOutroSequence();
  }

  /**
   * playFgOutroDesktopSpine method overrided to aligned containers as per functionality
   */
  private setOutroTickupYPosition(): void {
    const BOTTOM_Y_FOR_OUTRO_TICKUP: number = -287;
    const CENTER_Y_FOR_OUTRO_TICKUP: number = -309;

    this.outroWinTickupCont.y = (ingenuity.parserModel as GameParserModel).getIsJackpotAward()
      ? BOTTOM_Y_FOR_OUTRO_TICKUP
      : CENTER_Y_FOR_OUTRO_TICKUP;
  }

  // Method makeOutroSpinesVisible to update visibility and alpha values for the outro spines
  private makeOutroSpinesVisible(): void {
    this.fgOutroSpineContainer.visible = true;
    this.fgOutroSpine.visible = true;
    this.outroTextSpine.visible = true;
    this.fgOutroSpine.alpha = 1;
    this.outroTextSpine.alpha = 1;
  }

  // Play intro outro animations after a short delay
  private playOutroAnimations(): void {
    delayedCall("delaySpineDesktop", 50, () => {
      killDelayedCall("delaySpineDesktop");
      this.fgOutroSpine.setPause(false);
      this.outroTextSpine.setPause(false);
      this.fgOutroSpine?.onComplete.dispose();
      this.outroTextSpine?.onComplete.dispose();
      this.fgOutroSpine.playAnim("in_bg_desktop", false);
      this.outroTextSpine.playAnim("in_fg", false);
      this.outroTextSpine.onComplete.addOnce(()=>{
        this.setupLoopAnimations();
      });
    });
  }

  // Start the outro tick-up and coin emitter after a delay
  private startOutroSequence(): void {
    delayedCall("startOutroTickup", 700, () => {
      killDelayedCall("startOutroTickup");
      this.outroWinTickupCont.visible = true;
      this.initializeGrandJPEmitter();
      this.startGrandJPEmitter();
      this.startOutroTickup();

      if ((ingenuity.parserModel as GameParserModel).getIsJackpotAward()) {
        this.showJackpotWinOnOutro();
      }
    });
  }

  // Set up loop animations for the outro text spine
  private setupLoopAnimations(): void {
      this.fgOutroSpine.playAnim("loop_bg_desktop", true);
      this.outroTextSpine.playAnim("loop_fg", true);
  }

  /**
   * Add to play portrait mode free game intro spine animation
   */
  protected playFgIntroPortraitSpine() {
    this.fgIntroBGSPine.visible = true;
    this.freeGameIntroPortraitSpine.visible = true;
    this.fgIntroBGSPine.playAnim("in_bg_portrait", false);
    this.freeGameIntroPortraitSpine.playAnim("in_fg", false);
    this.freeGameIntroPortraitSpine.onComplete.addOnce(() => {
      this.fgIntroBGSPine.playAnim("loop_bg_portrait", true);
      this.freeGameIntroPortraitSpine.playAnim("loop_fg", true);
    }, this);
  }

  /**
   * Free game outro mtr fade out
   */
  protected fgOutroMeterFadeOut() {
    const delayToHideOutroAmount: number = 1200;
    const amountFadeOutTween: ITween = ingenuity.currentGame.add
      .tween(this.OutroWinAmount)
      .to({ alpha: 0 }, delayToHideOutroAmount, Linear.None, true, 0, 0, false);
    amountFadeOutTween.onComplete.addOnce(() => {
      amountFadeOutTween.stop();
      ingenuity.currentGame.tweens.remove(amountFadeOutTween);
    }, this);
    this.fadeOutBannerJackpots();
  }

  /**
   * method playFgOutroPortraitSpine overrided to update play spine during FG outro portrait
   */
  protected playFgOutroPortraitSpine() {
    this.fgOutroSpinePortrait.visible = true;
    this.outroTextSpinePortrait.visible = true;

    this.outroTextSpinePortrait?.onComplete.dispose();

    delayedCall("playSpine", 50, () => {
      killDelayedCall("playSpine");
      this.outroTextSpinePortrait.setPause(false);
      this.fgOutroSpinePortrait.setPause(false);
      this.fgOutroSpinePortrait.playAnim("in_bg_portrait", false);
      this.outroTextSpinePortrait.playAnim("in_fg", false);
    });

    this.fgOutroSpinePortrait.onComplete.addOnce(() => {
      this.outroTextSpinePortrait.playAnim("loop_fg", true);
      this.fgOutroSpinePortrait.playAnim("loop_bg_portrait", true);
    }, this);
  }

  /**
   * Add to play desktop free game intro spine animation
   */
  protected playFgIntroDesktopSpine() {
    this.freeGameIntroSpine.visible = true;
    this.introTextSpine.visible = true;
    if (ingenuity.soundManager.getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD)) {
      ingenuity.soundManager.getSoundInstance(
        SoundConstant.BASEGAME_BGMLOOP,
        gameConstants.SOUND_LIST_PRELOAD
      ).volume = 0.3;
    }
    if (ingenuity.soundManager.getSoundInstance(SoundConstant.BASEGAME_BGM_INTRO, gameConstants.SOUND_LIST_PRELOAD)) {
      ingenuity.soundManager.getSoundInstance(
        SoundConstant.BASEGAME_BGM_INTRO,
        gameConstants.SOUND_LIST_PRELOAD
      ).volume = 0.3;
    }
    if (ingenuity.soundManager.getSoundInstance(SoundConstantGame.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD)) {
      ingenuity.soundManager.getSoundInstance(
        SoundConstantGame.MUSIC_SPIN,
        gameConstants.SOUND_LIST_PRELOAD
      ).volume = 0.3;
    }
    (ingenuity.soundManager as any).play(SoundConstantGame.FREE_GAME_INTRO, 1, false, gameConstants.SOUND_LIST_PRELOAD);
    dispatcher.fireEvent(eventDispatchers.SHOW_BLUR_BACKGROUND, eventDispatchers.SHOW_FG_INTRO_BLUR_BG);
    this.introTextSpine.playAnim("in_fg", false);
    this.freeGameIntroSpine.playAnim("in_bg_desktop", false);
    this.freeGameIntroSpine.onComplete.addOnce(() => {
      this.continueButton.visible = true;
      this.tapToClickContainer.visible = true;
      this.freeGameIntroSpine.playAnim("loop_bg_desktop", true);
      this.introTextSpine.playAnim("loop_fg", true);
    }, this);
  }

  /**to handle continue button pressup action */
  private onContinuePressUP(): void {
    this.tapToClickContainer.visible = false;
    this.continueButton.visible = false;
    this.onIntroFinishDesktop();
    if (!ingenuity.deviceEnv.isDesktop) {
      this.onIntroFinishPortrait();
    }
  }

  /**to play Fg Intro Animation in Portrait */
  private onIntroFinishPortrait(): void {
    this.fgIntroBGSPine.playAnim("out_bg_portrait", false);
    this.freeGameIntroPortraitSpine.playAnim("out_fg", false);
    this.freeGameIntroPortraitSpine.onComplete.addOnce(() => {
      this.fgIntroBGSPine.visible = false;
      this.freeGameIntroPortraitSpine.visible = false;
    }, this);
  }

  /**to play Fg Intro animation in Desktop */
  private onIntroFinishDesktop(): void {
    this.introTextSpine.playAnim("out_fg", false);
    this.freeGameIntroSpine.playAnim("out_bg_desktop", false);
    this.freeGameIntroSpine.onComplete.addOnce(() => {
      this.freeGameIntroSpine.visible = false;
      this.introTextSpine.visible = false;
      delayedCall(gameConstants.INTRO_HIDE_DELAY, gameConstants.DURATION_300, () => {
        killDelayedCall(gameConstants.INTRO_HIDE_DELAY);
        this.onIntroContinuePressUp();
      }, this);
    }, this);
  }

  /**
   * method playFgOutroPortraitSpine overrided to to hide textAndNumberContainer
   */
  protected showTextAndNumberWithFadeIn(): void {
    // Emptied to stop execution
  }

  /**
   * method initializeGrandJPEmitter to initialize grand emitter
   */
  private initializeGrandJPEmitter(): void {
    const particleData: any = {
      emitterType: 1,
      id: "winCoinEmitter1",
      autoStart: false,
      animConfig: [
        {
          framerate: 20,
          loop: true,
          image: "Coin_rotation",
          generateFrames: true,
          frames: [0, 14],
        },
      ],
    };
    const config = {
      alpha: {
        start: 1,
        end: 1,
      },
      scale: {
        start: 1,
        end: 0.5,
        minimumScaleMultiplier: 0.5,
      },
      speed: {
        start: 300,
        end: 300,
        minimumSpeedMultiplier: 2,
      },
      acceleration: {
        x: 0,
        y: 0,
      },
      maxSpeed: 0,
      startRotation: {
        min: 0,
        max: 360,
      },
      noRotation: true,
      rotationSpeed: {
        min: 0,
        max: 10,
      },
      lifetime: {
        min: 1,
        max: 25,
      },
      blendMode: "normal",
      frequency: 0.035,
      emitterLifetime: -1,
      maxParticles: 110,
      pos: {
        x: 0,
        y: 0,
      },
      addAtBack: false,
      spawnType: "point",
    };
    const coinShowerContainer: Container = this.view.getContainerByID("coinShowerContainer");
    coinShowerContainer.mask = this.coinShowerContainerMask;
    ingenuity.currentGame.add.emitter(coinShowerContainer, particleData, config) as any;
  }

  /**
   * method startGrandJPEmitter to initialize grand jp emitter
   */
  private startGrandJPEmitter(): void {
    this.grandJpEmitter = ingenuity.currentGame.particles.getEmitterById("winCoinEmitter1");
    this.grandJpEmitter.autoUpdate = true;
    this.grandJpEmitter.emit = true;
  }

  // Method to calculate jackpot block
  private setJackpotAlignment(): void {
    let totalWidth: number = 0;
    const jackpotUIArrayLength: number = this.jackpotUIArray.length;

    for (let index: number = 0; index < jackpotUIArrayLength; index++) {
      const jackpot: Bitmap = this.jackpotUIArray[index];
      jackpot.visible = true;
      jackpot.x = totalWidth;
      totalWidth += jackpot.width;

      if (index < jackpotUIArrayLength - 1) {
        const plusSign: Bitmap = this.view.getImageById(`${this.OUTRO_PLUS + index}`);
        plusSign.x = totalWidth;
        plusSign.visible = true;
        this.plusUIArray.push(plusSign);
        totalWidth += plusSign.width;
      }
    }
  }

  /**
   * Method to show jackpot win outro on free game outro banner.
   * @param jackpotData
   */
  private showJackpotWinOnOutro(): void {
    this.jackpotUIArray = [];
    this.jackpotWinFadeIn();
    this.view.outroJackpotContainer.visible = true;
    this.getJpBannerForOutro((ingenuity.parserModel as GameParserModel).getjackpotMultipliersFG());
    this.setJackpotAlignment();
    this.view.setJpUIContainerAlignment();
  }

  /**
   * Method to set multiplier value on jackpot outro banner.
   * @param jackpotId
   * @param multiplier
   */
  private setJackpotMultiplier(jackpotId: string, multiplier: number): void {
    const multiplierMeter: MeterBitmapGame = this.view.getMeterById(jackpotId + this.METER_STR) as MeterBitmapGame;
    multiplierMeter.setText(multiplier.toString() + "X");
  }

  /**
   * Method to update UI for jackpot win blocks banner.
   * @param jackpotData
   */
  private getJpBannerForOutro(jackpotData: any): void {
    for (const key in jackpotData) {
      let jackpotId: string = "";
      const value = jackpotData[key];
      value && this.setJackpotMultiplier(key, value);
      if (value === 1) {
        jackpotId = `${key}${this.CONTAINER}`;
        const jackpotUI = this.view.getContainerByID(`${jackpotId}`);
        this.jackpotUIArray.push(jackpotUI);
      } else if (value > 1) {
        jackpotId = `${key}${this.MULTIPLIER_CONTAINER}`;
        const jackpotUI = this.view.getContainerByID(`${jackpotId}`);
        this.jackpotUIArray.push(jackpotUI);
      }
    }
  }

  /**
   * Method to fade in jackpot win banner.
   */
  private jackpotWinFadeIn(): void {
    this.view.outroJackpotMainContainer.alpha = 0;
    this.view.outroJackpotMainContainer.visible = true;
    const alphaTween: ITween = ingenuity.currentGame.add
      .tween(this.view.outroJackpotMainContainer)
      .to({ alpha: 1 }, 1000, Linear.None, true, 0, 0, false);
    alphaTween.onComplete.addOnce(() => {
      alphaTween.stop();
      ingenuity.currentGame.tweens.remove(alphaTween);
    }, this);
  }

  /**
   * Method stopSoundAndShowBaseGame overrided to update sound functionality
   */
  protected stopSoundAndShowBaseGame(): void {
    super.stopSoundAndShowBaseGame();
    if ((ingenuity.parserModel as GameParserModel).getIsMagicPotionBG()) {
      dispatcher.fireEvent(eventDispatchers.SHOW_MAGIC_POTION);
    }
    if (
      (ingenuity.soundManager as any).getSoundInstance(
        SoundConstantGame.FREE_GAME_BGM,
        gameConstants.SOUND_LIST_POSTLOAD
      )
    ) {
      (ingenuity.soundManager as any).stop(SoundConstantGame.FREE_GAME_BGM, gameConstants.SOUND_LIST_POSTLOAD);
    }
    (ingenuity.soundManager as any).stop(SoundConstantGame.FREE_GAME_OUTRO, gameConstants.SOUND_LIST_POSTLOAD);
    // if (
    //   (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.VOICE_INTRO, gameConstants.SOUND_LIST_PRELOAD)
    // ) {
    //   (ingenuity.soundManager as any).stop(SoundConstantGame.VOICE_INTRO, gameConstants.SOUND_LIST_PRELOAD);
    // }
    if (
      (ingenuity.soundManager as any).getSoundInstance(
        SoundConstantGame.FS_WIN_VOICE,
        gameConstants.SOUND_LIST_POSTLOAD
      )
    ) {
      (ingenuity.soundManager as any).stop(SoundConstantGame.FS_WIN_VOICE, gameConstants.SOUND_LIST_POSTLOAD);
    }
    this.playBaseGameSound();
  }

  /**
   * Method playBaseGameSound to add sound
   */
  private playBaseGameSound(): void {
    (ingenuity.soundManager as any).playSound(
      SoundConstant.BASEGAME_BGMLOOP,
      1,
      true,
      gameConstants.SOUND_LIST_PRELOAD
    );
  }

  /**overrided to remove freespin start delay */
  protected onIntroContinuePressUp(): void {
    ingenuity.configData.isReelSpinMusicPlaying = false;
    dispatcher.fireEvent(eventDispatchers.HIDE_BLUR_BACKGROUND, eventDispatchers.HIDE_FG_INTRO_BLUR_BG);
    super.onIntroContinuePressUp();
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_TOP_GAME_LOGO);
    (ingenuity.soundManager as any).stop(SoundConstantGame.FREE_GAME_INTRO, gameConstants.SOUND_LIST_POSTLOAD);
    // (ingenuity.soundManager as any).playSound(
    //   SoundConstantGame.ALTERNATIVE_START_FS_VOICE,
    //   1,
    //   false,
    //   gameConstants.SOUND_LIST_POSTLOAD
    // );
  }

  /**
   * Method stopBaseGameSound to stop base game sound on free game intro show.
   */
  private stopBaseGameSound(): void {
    // if (
    //   (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.VOICE_INTRO, gameConstants.SOUND_LIST_PRELOAD)
    // ) {
    //   (ingenuity.soundManager as any).stop(SoundConstantGame.VOICE_INTRO, gameConstants.SOUND_LIST_PRELOAD);
    // }
    if (
      (ingenuity.soundManager as any).getSoundInstance(
        SoundConstant.BASEGAME_BGM_INTRO,
        gameConstants.SOUND_LIST_PRELOAD
      )
    ) {
      (ingenuity.soundManager as any).stop(SoundConstant.BASEGAME_BGM_INTRO, gameConstants.SOUND_LIST_PRELOAD);
    }
    if (
      (ingenuity.soundManager as any).getSoundInstance(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD)
    ) {
      (ingenuity.soundManager as any).stop(SoundConstant.BASEGAME_BGMLOOP, gameConstants.SOUND_LIST_PRELOAD);
    }
    if (
      (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD)
    ) {
      (ingenuity.soundManager as any).stop(SoundConstantGame.MUSIC_SPIN, gameConstants.SOUND_LIST_PRELOAD);
    }
  }

  /**
   * Method playFreeGameIntroSpine override to stop base game sound
   */
  protected playFreeGameIntroSpine(): void {
    this.stopBaseGameSound();
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
        if ((ingenuity.parserModel as GameParserModel).getTotalBaseGameWinAmt() === 0) {
            dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASE_GAME_WIN_METER);
        }
        this.showTextAndNumberWithFadeIn();
        if (ingenuity.deviceEnv.isDesktop) {
            this.playFgIntroDesktopSpine();
        }
        else {
            this.playFgIntroDesktopSpine();
            this.playFgIntroPortraitSpine();
        }
  }

  /**
   * Override to fade 2nd free game bgm
   */
  protected onOutroShow(): void {
    const freegameBGMFadeDelayTime: number = 1000;
    super.onOutroShow();
    if (
      (ingenuity.soundManager as any).getSoundInstance(
        SoundConstantGame.FREE_GAME_BGM,
        gameConstants.SOUND_LIST_POSTLOAD
      )
    ) {
      (ingenuity.soundManager as any).fadeVolume(
        SoundConstantGame.FREE_GAME_BGM,
        freegameBGMFadeDelayTime,
        0,
        gameConstants.SOUND_LIST_POSTLOAD,
        () => {
          (ingenuity.soundManager as any).stop(SoundConstantGame.FREE_GAME_BGM, gameConstants.SOUND_LIST_POSTLOAD);
        },
        this
      );
    }
  }

  /**
   * Override to show blur BG
   */
  protected showFgOutroSpine(): void {
    this.OutroContinueBtn && (this.OutroContinueBtn.alpha = 1);
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
    dispatcher.fireEvent(SlotEventConstants.UNSCBSCRIBE_METER_CONTROLLERS_FG);
    if (this.outroWinAmount) {
      this.continueButtonOutroWin?.on(ButtonBaseBehavior.UP, this.onOutroWinContinuePressUP, this);
      this.continueButtonOutroWin?.off(ButtonBaseBehavior.UP, this.onOutroContinuePressUpForNoWin, this);
      dispatcher.fireEvent(eventDispatchers.SHOW_BLUR_BACKGROUND, eventDispatchers.SHOW_FG_OUTRO_BLUR_BG);
      if (ingenuity.deviceEnv.isDesktop) {
        this.playFgOutroDesktopSpine();
      } else {
        this.playFgOutroDesktopSpine();
        this.playFgOutroPortraitSpine();
      }
    } else {
      this.continueButtonOutroWin?.on(ButtonBaseBehavior.UP, this.onOutroContinuePressUpForNoWin, this);
      this.continueButtonOutroWin?.off(ButtonBaseBehavior.UP, this.onOutroWinContinuePressUP, this);
      this.fgOutroSpineContainer.visible = false;
      this.showNoWinPopUp();
    }
  }
  /**
   * Add to show pop up in no win case
   */
  protected showNoWinPopUp() {
    this.freeGameComplete.visible = true;
    this.freeGameComplete.alpha = 0;
    const fadeInTween = ingenuity.currentGame.add.tween(this.freeGameComplete).to({ alpha: 1 }, 250, Linear.None, true, 0, 0, false);
    fadeInTween.onComplete.addOnce(() => {
      ingenuity.currentGame.tweens.remove(fadeInTween);
      this.continueButtonOutroWin?.enableAndTint();
            this.tapToClickContainerOutro.visible = true;
    }, this);
  }
  /**to handle outro continue button pressup */
  private onOutroWinContinuePressUP(): void {
    this.tapToClickContainer.visible = false;
    this.continueButtonOutroWin.disableAndTint();
    this.continueButtonOutroWin.visible = false;
    ingenuity.configData.showBaseGameScreen = true;
    this.onOutroContinuePressUp();
    this.turnOffButtonHandler()
  }

  // /**to show outro continue button */
  // private showOutroWinContinueButton(): void {
  //   this.tapToClickContainerOutro.visible = true;
  //   this.continueButtonOutroWin.visible = true;
  // }

  /**
   * Override onOutroContinuePressUp to hide blur background
   */
  protected onOutroContinuePressUp(): void {
    ingenuity.currentGame.ticker.remove(this.setContainersPivot, this);
    dispatcher.fireEvent(eventDispatchers.HIDE_BLUR_BACKGROUND, eventDispatchers.HIDE_FG_OUTRO_BLUR_BG);
    this.tapToClickContainerOutro.visible = false;
    this.playFgOutroEndSpine();
    this.fgOutroMeterFadeOut();
    this.stopSoundAndShowBaseGame();
    delayedCall(
      SlotConstantsBehavior.OUTRO_HIDE_DELAY,
      800,
      () => {
        killDelayedCall(SlotConstantsBehavior.OUTRO_HIDE_DELAY);
        dispatcher.fireEvent(SlotEventConstants.OUTRO_HIDE);
        this.OutroContainer.visible = false;
        if (ingenuity.deviceEnv.isDesktop) {
          this.fgOutroSpine.visible = false;
        } else {
          this.fgOutroSpine.visible = false;
          this.fgOutroPortraitSpine.visible = false;
        }
      },
      this
    );
    // dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
  }

  /**
   * Method is overrided to hide win meter in case of no win
   */
  protected onOutroContinuePressUpForNoWin(): void {
    this.stopSoundAndShowBaseGame();
    dispatcher.fireEvent(SlotEventConstants.OUTRO_HIDE);
    this.tapToClickContainerOutro.visible = false;
    this.OutroContinueBtn?.disableAndTint();
    this.OutroContinueBtn && (this.OutroContinueBtn.alpha = 0);
    this.OutroContainer.visible = false;
    this.freeGameComplete.visible = false;
    if ((ingenuity.parserModel as GameParserModel).getFreeSpinTotalWin() || (ingenuity.parserModel as GameParserModel).getTotalWin()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BASE_GAME_WIN_METER);
    } else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_BASE_GAME_WIN_METER);
    }
    this.turnOffButtonHandler();
  }

  /**
   * fadeOutBannerJackpots to fade jp banners
   */
  private fadeOutBannerJackpots(): void {
    const amountFadeOutTween: ITween = ingenuity.currentGame.add
      .tween(this.view.outroJackpotMainContainer)
      .to({ alpha: 0 }, 200, Linear.None, true, 0, 0, false);
    amountFadeOutTween.onComplete.addOnce(() => {
      this.resetOutBannerJackpots();
      amountFadeOutTween.stop();
      ingenuity.currentGame.tweens.remove(amountFadeOutTween);
    }, this);
  }

  /**
   * resetOutBannerJackpots to reset jackpot containers
   */
  private resetOutBannerJackpots(): void {
    this.view.outroJackpotMainContainer.visible = false;
    this.view.outroJackpotMainContainer.alpha = 1;
    this.jackpotUIArray.length &&
      this.jackpotUIArray.forEach((element: any) => {
        element.visible = false;
      }, this);
    this.plusUIArray.length &&
      this.plusUIArray.forEach((element: any) => {
        element.visible = false;
      }, this);
  }

  /** to show fg outro win amount tickup for 500 MS */
  protected startOutroWinAmountTickup() {
    let winMtr;
    this.OutroWinAmount.setValue(0);
    this.OutroWinAmount.visible = true;
    this.OutroWinAmount.alpha = 1;
    (winMtr = this.OutroWinAmount) === null || winMtr === void 0
      ? void 0
      : winMtr.startTick(this.outroWinAmount, true, false, 6, true, () => {
        this.tapToClickContainerOutro.visible = true;
        this.continueButtonOutroWin.visible = true;
        this.continueButtonOutroWin.enableAndTint();
      });
    ingenuity.currentGame.ticker.add(this.setContainersPivot, this)
  }
  private turnOffButtonHandler():void{
    this.continueButtonOutroWin.off(ButtonBaseBehavior.UP, this.onOutroWinContinuePressUP, this);
    this.continueButtonOutroWin.off(ButtonBaseBehavior.UP, this.onOutroContinuePressUpForNoWin, this);
  }
}
